import React from "react";

import handsOnHeadImg from '../../../../assets/images/hands-on-head.png';
import problemsSolveArcImg from '../../../../assets/images/problemsSolveArc.png';

import { Row, Col } from "reactstrap";

import './style.scss'; 

export default function Problems () {
    const isMobile = window.screen.width < 768;

    return (
            <Row className="problems">
                <Col xs={12} md={5}>
                    <img className="hands-on-head" src={handsOnHeadImg} alt="hands on head"/>
                </Col>
                <Col className="problems-col" xs={12} md={7}>
                    <h2 className="heading-2">Problems We Solve</h2>
                    <div className="pink-text-container">
                        <span className="text-bold-color">Resource Constraints: </span>
                        <span className="body-text-big">Struggling to meet project deadlines? Our flexible staffing solutions provide the additional resources you need, when you need them.</span>
                    </div>
                    <div className="pink-text-container">
                        <span className="text-bold-color"> Skill Gaps: </span>
                        <span className="body-text-big">Finding it hard to locate specialized talent? Our extensive network of skilled professionals ensures you have access to the specific expertise required for your projects.</span>
                    </div>
                    <div className="pink-text-container">
                        <span className="text-bold-color">Unpredictable Workloads: </span>
                        <span className="body-text-big">Managing fluctuating demands can be daunting. We offer scalable solutions that allow you to adjust your team size based on project requirements, minimizing waste and maximizing efficiency.</span>
                    </div>
                </Col>
                {!isMobile 
                    ? <img src={problemsSolveArcImg} className="problems-solved-arc" alt="problems arc"/>
                    : <></>
                }
            </Row>
    )
}
